import { useQueryClient } from '@tanstack/react-query';
import { useUser } from './useUser';
import { queryKeys } from './queryKeys';

export const useRefetchAll = () => {
  const queryClient = useQueryClient();
  const { user } = useUser();

  const refetchUser = async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: queryKeys.user, exact: true }),
      queryClient.removeQueries({ queryKey: queryKeys.subscriptions, exact: true }),
    ]);
  };

  const refetchAll = async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: queryKeys.user, exact: true }),
      queryClient.invalidateQueries({ queryKey: queryKeys.physio(user?.user_id), exact: true }),
      queryClient.invalidateQueries({ queryKey: queryKeys.subscriptions, exact: true }),
      queryClient.removeQueries({ queryKey: queryKeys.trainingPlan(user?.current_plan), exact: true }),
      queryClient.removeQueries({ queryKey: queryKeys.trainingPlanNoBackup, exact: true }),
      queryClient.invalidateQueries({ queryKey: queryKeys.metadata(user?.current_plan), exact: true }),
      queryClient.invalidateQueries({ queryKey: queryKeys.connectionProviders, exact: true }),
      queryClient.removeQueries({ queryKey: queryKeys.progress }),
      queryClient.removeQueries({ queryKey: queryKeys.calendar, exact: true }),
      queryClient.removeQueries({ queryKey: queryKeys.trainingSettings, exact: true }),
      // Prefix, not exact: the V2 key carries the range, and a regeneration invalidates every one.
      queryClient.removeQueries({ queryKey: ['enrollment-sessions'] }),
    ]);
  };

  return { refetchAll, refetchUser };
};
